import { configureStore } from "@reduxjs/toolkit";
import trafficReducer from '../layout/TrafficSources/trafficSlice'
import firstLastReducer from '../layout/FirstLastTouch/firstlastSlice'
import personaReducer from "../layout/Persona/personaSlice.js";
import emailCustomerReducer from '../layout/EmailCustomers/emailSlice'
import nudgeReducer from "../layout/CustomizedNudge/nudgeSlice";//
import chatabotReducer from "../layout/Chatbot/chatabotSlice.js";
import authReducer from "../common/authenticateDashboard/authSlice.js";
import uniqueBnDevReducer from "../layout/Main/components/UniqueBnDev/uniqueBnDevSlice.js";
import sessionDistributionReducer from "../layout/Main/components/SessionDistribution/sessionDistributionSlice.js";
import UniqueBookingsReducer from "../layout/Main/components/UniqueBookings/uniqueBookingsSlice.js";
import UniqueBoughtReducer from "../layout/Main/components/UniqueBought/uniqueBoughtSlice.js";
import TrafficSourceReducer from "../layout/Main/components/TrafficSource/trafficSourceSlice.js";
import UTMSourceReducer from "../layout/MarketingPerformance/components/UTMSource/utmSourceSlice.js";
import UTMMediumReducer from "../layout/MarketingPerformance/components/UTMMedium/utmMediumSlice.js";
import UTMCampaignReducer from "../layout/MarketingPerformance/components/UTMCampaign/utmCampaignSlice.js";
import UTMContentReducer from "../layout/MarketingPerformance/components/UTMContent/utmContentSlice.js";
import UTMTermReducer from "../layout/MarketingPerformance/components/UTMTerm/utmTermSlice.js";
import UTMOverallReducer from "../layout/MarketingPerformance/components/UTMOverall/utmOverallSlice.js";
import NudgeCouponReducer from "../layout/Persona/components/NudgeBasedPerformance/nudgeCouponSlice.js";
import FacebookAdsReducer from "../layout/FunnelLeakage/components/FacebookAds/FacebookAdsSlice.js";
import GoogleAdsReducer from "../layout/FunnelLeakage/components/GoogleAds/GoogleAdsSlice.js";
import userDesignsReducer from "../layout/DesignEditor/designEditorSlice.js"
import HeatmapXUserSegmentReducer from "../layout/HeatmapXUserSegment/HeatmapXUserSegmentSlice.js";
import BookingPlatformReducer from "../layout/BookingPlatform/BookingPlatformSlice.js";
import metricsReducer from "../layout/ABTest/store/metricsSlice.js"
import abtestReducer from "../layout/ABTest/store/abtestSlice.js"
import geoReducer from "../features/geo/geoSlice";
import agentReducer from "../layout/AIAgent/agentSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        traffic: trafficReducer,
        firstLast: firstLastReducer,
        persona: personaReducer,
        emailCustomer: emailCustomerReducer,
        nudge: nudgeReducer,
        chatbot: chatabotReducer,
        uniqueBnDev: uniqueBnDevReducer,
        sessionDistribution: sessionDistributionReducer,
        uniqueBookings: UniqueBookingsReducer,
        uniqueBought: UniqueBoughtReducer,
        trafficSource: TrafficSourceReducer,
        utmSource: UTMSourceReducer,
        utmMedium: UTMMediumReducer,
        utmCampaign: UTMCampaignReducer,
        utmContent: UTMContentReducer,
        utmTerm: UTMTermReducer,
        utmOverall: UTMOverallReducer,
        facebook: FacebookAdsReducer,
        google_ads: GoogleAdsReducer,
        nudgeCoupon: NudgeCouponReducer,
        userDesigns: userDesignsReducer,
        userHeatmap: HeatmapXUserSegmentReducer,
        booking: BookingPlatformReducer,
        metrics: metricsReducer, 
        abtest: abtestReducer,
        geo: geoReducer,
        agent: agentReducer,
    }
})

export default store;